import styled from "styled-components";
import { Modal } from "components/Modal";

export const QuestionContainer = styled(Modal)`
  .modal-dialog {
    max-width: 582px;
  }

  .modal-content {
    padding: 0px;
    height: 512px;
    margin: 0px;
    border: 0px;

    .modal-body {
      padding: 0 0 2rem 0;
      margin-top: 0px;

      .heading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 52px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background: linear-gradient(
          to right,
          #3b4baa 0%,
          #9387ca 33%,
          #4b74c0 67%,
          #3b4baa 100%
        );
        padding-top: 0px;
      }

      .body-content {
        padding: 0px 20px;
      }
      .progress-row {
        align-items: center;
        margin: 20px 0px;

        [class*="col-"] {
          padding: 0px;
        }

        .progress {
          height: 4.5px;
          background-color: ${({ theme }) => theme.global.bg.progressBar};

          .progress-bar {
            background-color: #048af5;
          }
        }

        .steps {
          font-size: 14px;
          font-weight: 400;
          padding-left: 10px;
          text-wrap: nowrap;
          color: #048af5;
        }
      }

      form {
        display: flex;
        flex-direction: column;
        gap: 21px;
        max-height: 315px;
        overflow-y: scroll;

        .loader {
          position: absolute;
          top: 40%;
          justify-content: center;
          width: 100%;
        }

        .question {
          font-size: 15px;
          font-weight: 500;
          line-height: 20px;
        }

        .options {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 14px;
          font-weight: 400;
          padding-left: 5px;

          input,
          label {
            cursor: pointer;
          }
        }

        button {
          margin-top: 20px;
        }

        .button-wrapper {
          position: absolute;
          bottom: 20px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
        }
      }
    }

    @media (max-width: 768px) {
      .modal-body {
        .steps {
          text-wrap: wrap !important;
        }
      }
    }
  }
`;
